import styled from 'styled-components'

export const LocationAddModalWrapper = styled.div``
